import { gql } from '@apollo/client';

export const FETCH_SCHEDULED_TRANSFERS_QUERY = (permissions: string[]) => `
  query fetchScheduledTransfers($input: FetchScheduledTransfersInput!) {
    fetchScheduledTransfers(input: $input) {
      scheduledTransfers {
        id
        amountCents
        state
        type
        subAccount {
          id
          account {
            id
            type
            user {
              id
              ${permissions.includes('read:client_low_risk_pii') ? 'firstName middleName lastName' : ''}
            }
          }
          goal {
            name
          }
        }
        toSubAccount {
          id
          goal {
            name
          }
          account {
            type
          }
        }
        bankAccount {
          name
          institutionNumber
          bankAccountNumber
        }
        scheduledDate
        frequency
      }
      totalCount
    }
  }
`;

export const FETCH_SCHEDULED_TRANSFERS = (permissions: string[]) =>
  gql`${FETCH_SCHEDULED_TRANSFERS_QUERY(permissions)}`;

export const CANCEL_SCHEDULED_TRANSFER = gql`
  mutation cancelScheduledTransfer($scheduledTransferId: ObjectID!) {
    cancelScheduledTransfer(scheduledTransferId: $scheduledTransferId) {
      scheduledTransfer {
        id
      }
    }
  }
`;
